<p-multiSelect
    [id] = "id()"
    [ngModel]="isLoading() ? [] : selectedTradeClassKeys()"

    [options]="options()"
    optionLabel="tradeClassName"
    optionValue="tradeClassKey"
    dataKey="tradeClassKey"
    
    [placeholder]="isLoading() ? 'Loading trade classes...' : placeHolder()"
    [loading]="isLoading()"
    [showClear]="true"

    [disabled]="isDisabled()"
    [invalid]="isInvalid()"

    (ngModelChange)="onModelChange($event)"
    (onBlur)="blur.emit()"

    fluid
    >
</p-multiSelect>